import React, { useState } from 'react'
import { useTranslation } from '../../../../context/translationProvider'
import { useAidCustomer } from '../../../../hooks/useAidCustomer'
import { getAidCustomerSteps } from '../../../organisms/AidCustomerWizard/utils'
import { Modal } from '../../../atoms/modal'
import { If } from '../../../atoms/if'
import ProblemWizard from '../../AidResultWizard/ProblemWizard'
import SuccessWizard from '../../AidResultWizard/SuccessWizard'
import AidCustomerWizard from '../../../organisms/AidCustomerWizard'
import {
  CloseConfirmationContent,
  CloseTitleContent,
  Content,
  Wrapper,
} from './styles'
import { CAFSteps } from '../../../organisms/CAFSteps'
import { ImageWrapper, Message } from '../../../organisms/CAFSteps/styles'
import { Image } from '../../../atoms/image'
import { Title } from '../../../atoms/text'
import { Button } from '../../../atoms/button'
import lockIcon from '../../../../images/icon_lock_gray.svg'
import PropTypes from 'prop-types'

const CafPixPingModal = (props) => {
  const {
    isOpen,
    onClose,
    cafIframeUrl,
    closeCafIFrame,
    startAltDescription,
  } = props

  const [verificationStarted, setVerificationStarted] = useState(false)
  const [isRejected, setIsRejected] = useState(false)
  const [confirmingClose, setConfirmingClose] = useState(false)

  const { translate } = useTranslation()

  const { aidWizards, toggleWizard, handleAttemptsFailedCount } =
    useAidCustomer()

  const aidCustomerSteps = getAidCustomerSteps(translate)

  const toggleContactUs = () => {
    if (!window?.Intercom) return
    if (window.isIntercomOpen) return

    window.Intercom('show')
  }

  const createCloseConfirmationContent = () => (
    <CloseConfirmationContent>
      <CloseTitleContent>
        <Title level={3}>
          {translate('addBankAccount.CloseVerificationTitle')}
        </Title>
      </CloseTitleContent>

      <ImageWrapper>
        <Image url={lockIcon} className="main-img" />
      </ImageWrapper>

      <Message>
        {translate('deposit.pixPing.closeVerification.message')}
      </Message>
      <Button
        expand
        style={{ 'margin-top': '0.5rem' }}
        onClick={() => {
          setConfirmingClose(false)
        }}
      >
        {translate('addBankAccount.CloseVerificationReturn')}
      </Button>
      <Button
        expand
        bordered
        dark
        style={{ 'margin-top': '1rem' }}
        onClick={() => {
          setConfirmingClose(false)
          onClose()
        }}
      >
        {translate('addBankAccount.CloseVerificationClose')}
      </Button>
    </CloseConfirmationContent>
  )

  return (
    <Modal
      theme="account-reopen"
      title={translate('deposit.pixPing.title')}
      isOpen={isOpen}
      onClose={setConfirmingClose}
      hideBackButton={true}
      hideClose={confirmingClose}
    >
      <Wrapper>
        <Content>
          <If
            condition={aidWizards.aidCustomer}
            render={() => (
              <AidCustomerWizard
                steps={aidCustomerSteps}
                onLastClick={() => toggleWizard('aidSuccess', true)}
                handleClose={() => {
                  toggleWizard('aidCustomer', false)
                  toggleWizard('aidSuccess', true)
                }}
              />
            )}
          />

          <If
            condition={aidWizards.aidSuccess}
            render={() => (
              <SuccessWizard
                onClose={() => toggleWizard('aidSuccess', false)}
                title={translate('aidCustomer.success.title')}
                description={translate('aidCustomer.success.description')}
              />
            )}
          />

          <If
            condition={aidWizards.aidProblem}
            render={() => (
              <ProblemWizard
                onClose={() => toggleWizard('aidProblem', false)}
                title={translate('aidCustomer.problem.title')}
                description={translate('aidCustomer.problem.description')}
                buttonText={translate('aidCustomer.problem.buttonText')}
                onClick={() => {
                  toggleContactUs()
                  toggleWizard('aidProblem', false)
                }}
              />
            )}
          />

          <If
            condition={confirmingClose}
            render={createCloseConfirmationContent}
            renderElse={() => (
              <CAFSteps
                cafIframeUrl={cafIframeUrl}
                onAttemptsFailed={handleAttemptsFailedCount}
                closeCafIFrame={closeCafIFrame}
                startAltDescription={startAltDescription}
                idVerificationStarted={verificationStarted}
                setIdVerificationStarted={setVerificationStarted}
                onStartVerification={() => setIsRejected(false)}
                showRejected={isRejected}
              />
            )}
          />
        </Content>
      </Wrapper>
    </Modal>
  )
}

CafPixPingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  cafIframeUrl: PropTypes.string.isRequired,
  closeCafIFrame: PropTypes.func.isRequired,
  startAltDescription: PropTypes.string.isRequired,
  setIsWaitingVerification: PropTypes.func.isRequired,
  isWaitingVerification: PropTypes.bool.isRequired,
}

export default CafPixPingModal
